import DefaultLayout from '@app/layouts/DefaultLayout';
import { RouteDefinition } from '@app/routes/routes.types';

import { SHOP_STORE_CODE_COOKIE } from './context/ShopStoreContext';
import TempAddProducts from './pages/TempAddProducts';
import Cart from './pages/Cart/Cart';
import Account from './pages/Account/Account';
import AccountLayout from './pages/Account/AccountLayout';
import OrderHistory from './pages/Account/OrderHistory/OrderHistory';
import OrderHistoryDetail from './pages/Account/OrderHistory/OrderHistoryDetail/OrderHistoryDetail';
import UpdatesAndDrivers from './pages/Account/UpdatesAndDrivers';
import LicenseTransfer from './pages/Account/LicenseTransfer';
import AccountSettings from './pages/Account/AccountSettings';
import Coupons from './pages/Account/Coupons/Coupons';
import CheckoutLayout from './pages/Checkout/CheckoutLayout';
import Address from './pages/Checkout/Address/Address';
import Review from './pages/Checkout/Review/Review';
import Delivery from './pages/Checkout/Delivery/Delivery';
import Payment from './pages/Checkout/Payment/Payment';
import Response from './pages/Checkout/Response/Response';
import ResponseLayout from './pages/Checkout/Response/ResponseLayout';
import Success from './pages/Checkout/Success/Success';
import SuccessLayout from './pages/Checkout/Success/SuccessLayout';

export { SHOP_STORE_CODE_COOKIE };

export const routes: RouteDefinition[] = [
  // For now redirect to temp add items page
  {
    path: '/:language/shop/',
    redirect: '/:language/shop/cart/',
    exact: true,
  },
  // FIXME: Remove when dev round complete, temp way to add items to cart
  {
    path: '/:language/shop/temp-add/',
    name: 'temp-add',
    component: TempAddProducts,
    layout: DefaultLayout,
  },
  {
    path: '/:language/shop/cart/',
    name: 'cart',
    component: Cart,
    layout: DefaultLayout,
  },
  {
    path: `/:language/account/`,
    name: 'account/index',
    component: Account,
    layout: AccountLayout,
    exact: true,
  },
  {
    path: `/:language/account/orders/`,
    name: 'account/orders',
    component: OrderHistory,
    layout: AccountLayout,
    exact: true,
  },
  {
    path: `/:language/account/orders/:orderNumber`,
    name: 'account/order-detail',
    component: OrderHistoryDetail,
    layout: AccountLayout,
  },
  {
    path: `/:language/account/license-transfer/`,
    name: 'account/license-transfer',
    component: LicenseTransfer,
    layout: AccountLayout,
  },
  {
    path: `/:language/account/vouchers/`,
    name: 'account/vouchers',
    component: Coupons,
    layout: AccountLayout,
  },
  {
    path: `/:language/account/account-settings/`,
    name: 'account/account-settings',
    component: AccountSettings,
    layout: AccountLayout,
  },
  {
    path: `/:language/account/updates-and-drivers/`,
    name: 'account/updates-and-drivers',
    component: UpdatesAndDrivers,
    layout: AccountLayout,
  },
  {
    path: `/:language/shop/checkout/`,
    name: `shop/checkout`,
    exact: true,
    redirect: `/:language/shop/checkout/address/`,
  },
  {
    path: `/:language/shop/checkout/address/`,
    name: `shop/checkout/address`,
    component: Address,
    layout: CheckoutLayout,
  },
  {
    path: `/:language/shop/checkout/review/`,
    name: `shop/checkout/review`,
    component: Review,
    layout: CheckoutLayout,
  },
  {
    path: `/:language/shop/checkout/delivery/`,
    name: `shop/checkout/delivery`,
    component: Delivery,
    layout: CheckoutLayout,
  },
  {
    path: `/:language/shop/checkout/payment/:status?/`,
    name: `shop/checkout/payment`,
    component: Payment,
    layout: CheckoutLayout,
  },
  {
    path: `/:language/shop/checkout/response/:cartId/`,
    name: `shop/checkout/response`,
    component: Response,
    layout: ResponseLayout,
  },
  {
    path: `/:language/shop/checkout/success/:orderNumber`,
    name: `shop/checkout/success`,
    component: Success,
    layout: SuccessLayout,
  },
];
